<template>
	<Tickets userType="admin" />
</template>

<script>

	export default {
		name: 'AgentTicketView',
		components: {
			'Tickets': () => import('@/components/ticket/AdminTickets.vue'),
		},
		data() {
			return {

			}
		}
	}
</script>
<style></style>
